import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Initialisiert scroll-gekoppelte Animationen für animierte Teaser-SVGs.
 * Unterstützt "baggage" (horizontal) und "rocket" (vertikal).
 */
function initTeaserAnimated() {
    const teaserSvgs = document.querySelectorAll('.teaser-animated-svg');

    if (!teaserSvgs.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
        return;
    }

    teaserSvgs.forEach((svg) => {
        const animationType = svg.dataset.teaserAnimated;

        if (animationType === 'baggage') {
            gsap.fromTo(
                svg,
                { x: '0' },
                {
                    x: '30%',
                    ease: 'none',
                    scrollTrigger: {
                        trigger: svg,
                        start: 'top 85%',
                        end: 'bottom 25%',
                        scrub: true,
                    },
                }
            );
        }

        if (animationType === 'rocket') {
            const rocket = svg.querySelector('.svg-rocket');

            if (!rocket) return;

            gsap.fromTo(
                rocket,
                { y: '0' },
                {
                    y: '-40%',
                    ease: 'none',
                    scrollTrigger: {
                        trigger: svg,
                        start: 'top 85%',
                        end: 'bottom 25%',
                        scrub: true,
                    },
                }
            );
        }
    });
}

initTeaserAnimated();
